{
  "contact-update-dialog": {
    "buttons": {
      "confirm": "Confirmer",
      "skip": "Sauter"
    },
    "text": {
      "confirm-email": "Confirmation par e-mail",
      "confirm-email-hint": "Veuillez confirmer votre e-mail",
      "confirm-phone-number": "Confirmation du numéro de téléphone",
      "confirm-phone-number-hint": "Veuillez confirmer votre numéro de téléphone",
      "enter-email": "L'e-mail est manquant",
      "enter-email-hint": "Veuillez indiquer votre adresse e-mail",
      "enter-phone-number": "Le numéro de téléphone est manquant",
      "enter-phone-number-hint": "Veuillez indiquer votre numéro de téléphone",
      "in-second": "en {{seconds}} s"
    }
  }
}
